module.exports = __webpack_public_path__ + "apple-touch-icon.a401e5cd.png";